import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { Heading } from '@ui/Heading'
import { Inline } from '@shared/layout/Inline'
import { COLORS } from '@assets/styles/colors'
import { CircularsList } from '@features/exercise/CircularsList'
import { Achievement } from '@features/Achievement'
import { FeedBack } from '@features/exercise/FeedBack'
import { ResultFooter } from '@widgets/exercise/ExerciseFooter'
import { RoundedBackground } from '@shared/layout/RoundedBackground'
import { IonText } from '@ionic/react'
import { trainingStore } from '@app/stores/trainingStore'

export const TrainingResultsPage = () => {
	const { endTime, startTime, completedExercises, exercisesAmount, programInfo } = trainingStore

	const timeDifference: number = Math.floor((+(endTime || 0) - +(startTime || 0)) / 1000)

	return (
		<DefaultPage style={{ paddingTop: 0 }}>
			<Content style={{ width: 'min(100vw, 500px)' }}>
				<RoundedBackground bgImage={programInfo.image}>
					<div
						style={{
							height: 'min(100%, 500px)',
							paddingLeft: 31,
							paddingBottom: 120,
							display: 'flex',
							justifyContent: 'flex-end',
							flexDirection: 'column',
						}}>
						<Heading size={21} weight={300} color={'white'}>
							{programInfo.name}
						</Heading>
						<IonText
							style={{
								fontSize: 12,
								fontWeight: 500,
								paddingTop: 6,
								color: 'white',
							}}>
							Программа выполняется
						</IonText>
					</div>
				</RoundedBackground>
				<div style={{ paddingInline: 15, marginTop: -30 }}>
					<Inline style={{ flexDirection: 'column' }} align={'center'}>
						<Heading
							size={21}
							color={COLORS.DECORATIVE_MEDIUM_BLUE}
							style={{ textAlign: 'center', marginTop: 0, lineHeight: 1.5 }}>
							Потрясающе,
							<br /> все упражнения выполнены
						</Heading>
						<CircularsList
							caloriesBurned={27}
							time={timeDifference}
							completedExercises={completedExercises}
							overallExercises={exercisesAmount}
							style={{ marginTop: 26 }}
						/>
					</Inline>
					<Achievement
						title={'Геракл'}
						description={'Вы завершили 5 тренировок'}
						newAchievementDescription={'Осталось еще 15 до следующего достижения'}
						percentage={33}
						style={{ marginTop: 21 }}
					/>
					<FeedBack style={{ marginTop: 21, marginBottom: 30 }} />
				</div>
			</Content>
			<ResultFooter />
		</DefaultPage>
	)
}
